import {Injectable} from "@angular/core";
import {ClientConfiguration} from "../configuration/client.config";
import {RaVersion} from "../configuration/ra.version";
import {TranslateService} from "@ngx-translate/core";

@Injectable()
export class AudioKeyParser {

    constructor(private config: ClientConfiguration, private translateService: TranslateService) {
        // this.setDefaultTranslation();
    }

    public parseAudioKeyUrl(key: string): string {
        this.setDefaultTranslation();
        let directory = this.config.getApplicationAudioPath() + this.translateService.currentLang;
        return directory + "/" + key + "_" + this.translateService.currentLang.toUpperCase() + ".mp3" + RaVersion.full;
    }

    private setDefaultTranslation(): void {
        if (this.config.isSuperUserMode) {
            this.translateService.use("en");
        }
    }
}
